import { useState } from "react";
import Skeleton from "react-loading-skeleton";

import * as S from "./styles";

const ImageLoader = ({ src, alt, width, height, className = "" }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <S.Wrapper loaded={loaded} className={className}>
      {loaded ? null : (
        <Skeleton
          height={height || "100%"}
          width={width || "100%"}
          baseColor="#878787"
          highlightColor="#636262"
        />
      )}

      <img src={src} alt={alt} onLoad={() => setLoaded(true)} />
    </S.Wrapper>
  );
};

export default ImageLoader;
